import { Block } from "@/components/Block";
import { CopyIcon } from "@/components/CopyIcon";
import { Countdown } from "@/components/Countdown";
import { useCustomerPopup } from "@/components/CustomerPopup";
import { MakeDialog } from "@/components/Dialog";
import {
  Header,
  HeaderActionBack,
  HeaderActionCustomerService,
} from "@/components/Header";
import { Icon } from "@/components/Icon";
import { Input } from "@/components/Input";
import { Layout } from "@/components/Layout";
import { PaymentIcons } from "@/components/PaymentIcons";
import { PaymentInfo } from "@/components/PaymentInfo";
import { ShowResult, usePopup } from "@/components/Popup";
import { TradeBoard } from "@/components/TradeBoard";
import { TradeSteps, TransactionStatusOnStep } from "@/components/TradeSteps";
import { OrderStatus, Payments } from "@/constants";
import { EC } from "@/constants/errors";
import { cn, validateFileSize } from "@/libs";
import { LocalError } from "@/libs/errors";
import { ComponentBase } from "@/types";
import tools, { toMoney } from "@/utils/tool";
import { useEventTarget, useToggle, useUnmount } from "ahooks";
import { Button, Image, ImageViewer, PullToRefresh, Toast,ImageUploader,ImageUploadItem } from "antd-mobile";
import { CloseCircleOutline } from "antd-mobile-icons";
import {
  dialogConfirmCancelTrading,
  dialogConfirmPaid,
  dialogUploadPaidCertification,
} from "./dialogs";
import styles from "./index.module.scss";
import "./index.scss";
import { useSetup } from "./logic";

let handler: ShowResult;

export const PageBuyTrading = () => {
  const logic = useSetup();
  const [showApplyArbitrateDialog] = usePopup();
  const [applyText, { onChange, reset }] = useEventTarget<string>();
  const [customerPopup] = useCustomerPopup();

  useUnmount(() => {
    handler?.close();
  });

  if (tools.isUndefined(logic.state.order)) return <></>;
  /** 展示倒计时组件   || logic.state.status === OrderStatus.TRANSFERRED  买家转账后隐藏时间 */  
  const showCountdown =
    logic.state.status === OrderStatus.BUYER_REQUEST ||
    logic.state.status === OrderStatus.WAITING_FOR_TRANSFER;

  const isCountdownEnd = logic.state.countdown <= 0;
  /** 展示付款信息 */
  const showPaymentInfomation =
    (logic.state.status === OrderStatus.TRANSFERRED && !isCountdownEnd) ||
    logic.state.status === OrderStatus.DISPUTING ||
    logic.state.status === OrderStatus.WAITING_FOR_TRANSFER;
  /** 展示买家已支付截图 */
  const showBuyerPaidScreenShot =
    TransactionStatusOnStep[logic.state.status] > 3;
  /** 等待转账 */
  const isWaitingForTransfer =
    logic.state.status === OrderStatus.WAITING_FOR_TRANSFER;
  /** 争议订单 */
  const isDisputing = logic.state.status === OrderStatus.DISPUTING;
  /** 订单超时，或是卖家没收到转账 */
  const isTimeoverOrSellerDidntRecived =
    logic.state.status === OrderStatus.TIME_OVER ||
    (logic.state.status === OrderStatus.SELLER_DID_NOT_RECEIVE &&
      !isCountdownEnd);
  /** 展示支付截图或截图上传组件 */
  const showPaidScreenShot =
    logic.state.status === OrderStatus.WAITING_FOR_TRANSFER ||
    logic.state.status === OrderStatus.TRANSFERRED ||
    logic.state.status === OrderStatus.DISPUTING ||
    (logic.state.status === OrderStatus.SELLER_DID_NOT_RECEIVE &&
      !isCountdownEnd);

  const dialogApplyArbitrate = () => {
    handler = showApplyArbitrateDialog({
      className: styles.applyArbitrateDialog,
      content: MakeDialog({
        title: "请简要描述您的申诉内容",
        confirmText: "提交申诉",
        cancelText: "取消",
        content: (
          <Input
            type="textarea"
            theme="plain"
            placeholder="0/50"
            maxLength={50}
            value={applyText}
            onChange={onChange}
          />
        ),
        async onConfirm() {
          const ok = await logic.applyArbitrate(applyText as string);
          ok && reset();
          handler?.close();
        },
        onCancel() {
          handler?.close();
        },
      }),
    });
  };

  return (
    <Layout
      ref={logic.scollableRef}
      backgroundImage={false}
      scrollable
      header={
        <Header
          title="我的买单"
          leftActions={[<HeaderActionBack key="back" />]}
          rightActions={[<HeaderActionCustomerService key="kefu" />]}
        />
      }
    >
      <PullToRefresh onRefresh={async () => logic.refreshFun()}>
        <Board
          state={logic.state.status as OrderStatus}
          orderDurations={logic.orderDurations}
        >
          {showCountdown && (
            <div className={styles.boardContentCountdown}>
              订单倒计时：
              <Countdown
                duration={logic.state.countdown}
                onFinish={() => logic.dispatch({ type: "finish-countdown" })}
              />
            </div>
          )}

          <div className={styles.boardContentOrderNumber}>
            订单编号：{logic.state.order.orderNo}
            <CopyIcon text={logic.state.order.orderNo} />
          </div>
        </Board>

        <Block
          topline
          title={
            <div className={styles.blockTitle}>
              购买数量
              <div className={styles.vcoinNumber}>
                <span>{toMoney(logic.state.order.amount)}</span>
                <Icon
                  className={styles.vcoin}
                  name="vcoin"
                  size={["28px", "14px"]}
                />
              </div>
            </div>
          }
        />
        <Block
          nextby
          title={
            <div className={styles.blockTitle}>
              支付方式
              <div className={styles.payments}>
                <PaymentIcons
                  payments={logic.state.order.paymentType}
                  size="24px"
                />
              </div>
            </div>
          }
        />
        <Block topline title="交易进度">
          <TradeSteps
            status={logic.state.status as OrderStatus}
            createTime={logic.state.order.createTime}
          />
        </Block>

        <Block topline title="卖家收款信息">
          {
            // isAutoOrder = 1 自动挂单
            logic.state.order.isAutoOrder === 1 ?(
              <div className={styles.autoOrder}>
                <div className={styles.centerBtn}>
                    <Button className={styles.goPayBtn} onClick={logic.jump2Pay} >
                      点击跳转支付
                    </Button>
                </div>
                <div className={styles.description}>
                  该用户为平台认证用户，请放心点击跳转后按要求支付
                </div>
                <div className={styles.certificated}>
                </div>
                <div className={styles.certification}></div>
              </div>
            ):(
                <PaymentInfo
                payment={logic.state.order.paymentType as Payments}
                show={showPaymentInfomation}
                info={logic.state.sellerPayment}
              />
            )
          }
        </Block>

        <Block topline title="买家付款信息">
          <PaymentInfo
            payment={logic.state.order.paymentType as Payments}
            show={showPaymentInfomation}
            info={logic.state.buyerPayment}
          />
        </Block>

        {showPaidScreenShot &&
          (showBuyerPaidScreenShot ? (
            <PreviewScreenShot
              src={logic.getSourcePath(
                logic.state.order.voucher || logic.state.voucher
              )}
            />
          ) : (
            <PaidScreenShotUploader
              onUpload={logic.uploadPaidScreenShot}
              onDelete={() =>
                logic.dispatch({ type: "update-voucher", voucher: "" })
              }
              voucher={
                logic.state.voucher
                  ? logic.getSourcePath(logic.state.voucher)
                  : logic.state.voucher
              }
            />
          ))}

        {isWaitingForTransfer && <TradingNotice />}

        <div className={styles.actions}>
          {isTimeoverOrSellerDidntRecived && (
            <div className={styles.floatBtn}>
              <Button
                className={styles.actionCancelTrading}
                onClick={() => dialogApplyArbitrate()}
              >
                申请客服介入
              </Button>
            </div>
          )}


          {/* TODO: 客服线 */}
          {isDisputing && (
            <div className={styles.floatBtn}>
              <Button className={styles.actionCancelTrading} onClick={()=> {customerPopup()}}>联系客服</Button>
            </div>
          )}
          {isWaitingForTransfer && (
            <div className={styles.TransferBtn}>
              {
                !logic.isBottom ? (
                  <p className={styles.downSlide}>向下滑动<Icon className={styles.iconArrow} name={"user-arrow-right"} size={"15px"} /></p>
                ):null
              }
              <Button
                className={styles.actionCancelTrading}
                onClick={async () => {
                  const data = await logic.checkCancelable();
                  if (data) {
                    dialogConfirmCancelTrading(
                      data,
                      logic.confirmCancelTrading
                    );
                  }
                }}
              >
                取消交易
              </Button>
              <Button
                className={styles.actionHasBeenTransfered}
                onClick={() => {
                  if (!logic.state.voucher)
                    return dialogUploadPaidCertification();

                  dialogConfirmPaid(logic.confirmPaid);
                }}
              >
                我已转账
              </Button>
            </div>
          )}
        </div>
      </PullToRefresh>
    </Layout>
  );
};

export interface BoardProps<T = OrderStatus> extends ComponentBase.Component {
  state: T;
  orderDurations: {
    waitingSellerCompletesOrderDelayTime: string;
    waitingSellerConfirmDelayTime: string;
    buyerPaysOvertimeDelayTime: string;
    ProfessionBuyerPaysOvertimeDelayTime?: string;
  };
  isProfession?:number;
}

/**
 * 订单的状态面板
 * @param param0
 * @returns
 */
const Board = ({
  children,
  state,
  orderDurations,
}: BoardProps<OrderStatus>) => {
  let text = null;

  switch (state) {
    case OrderStatus.BUYER_REQUEST:
      text = (
        <div>
          <div className={styles.boardBgTitle}>请等待卖家确认</div>
          <div className={styles.boardBgDesc}>
            卖家
            <span className={styles.boardBgDescHighlight}>
              {orderDurations.waitingSellerConfirmDelayTime}
            </span>
            内未确认订单
            <br />
            系统默认卖家取消交易
          </div>
        </div>
      );
      break;
    case OrderStatus.SELLER_CANCELED_DEAL:
      text = (
        <div>
          <div className={styles.boardBgTitle}>卖家取消交易</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case OrderStatus.WAITING_FOR_TRANSFER:
      text = (
        <div>
          <div className={styles.boardBgTitle}>请等待买家转账</div>
          <div className={styles.boardBgDesc}>
            买家
            <span className={styles.boardBgDescHighlight}>
              {orderDurations.buyerPaysOvertimeDelayTime}
            </span>
            未转账
            <br />
            系统默认买家取消交易
          </div>
        </div>
      );
      break;
    case OrderStatus.BUYRER_CANCELD_DEAL:
      text = (
        <div>
          <div className={styles.boardBgTitle}>买家取消交易</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case OrderStatus.TIME_OVER:
      text = (
        <div>
          <div className={styles.boardBgTitle}>超时取消交易</div>
          <div className={styles.boardBgDesc}>
            未操作超时取消，如有异议
            <br />
            请在<span className={styles.boardBgDescHighlight}><span className={styles.spanColor}>{orderDurations.waitingSellerConfirmDelayTime /* 30分钟 */}</span></span>
            内提交申请客
            <br />
            服介入，否则交易将自动结束
            <br />
            ，买家无法收到转币
          </div>
        </div>
      );
      break;
    case OrderStatus.TRANSFERRED:
      text = (
        <div>
          <div className={styles.boardBgTitle}>买家已转账</div>
          <div className={styles.boardBgDesc}>
            卖家确认付款后系统将
            <br />
            自动将币转入您的账户
          </div>
        </div>
      );
      break;
    case OrderStatus.SELLER_DID_NOT_RECEIVE:
      text = (
        <div>
          <div className={styles.boardBgTitle}>卖家未收到款</div>
          <div className={styles.boardBgDesc}>
            卖家已提交,未收到付款 如有异议
            <br />
            请在<span className={styles.boardBgDescHighlight}><span className={styles.spanColor}>{orderDurations.waitingSellerConfirmDelayTime /* 30分钟 */}</span></span>内
            提交申请客服介
            <br />
            入，否则交易将自动结束，买家
            <br />
            无法收到转币
          </div>
        </div>
      );
      break;
    case OrderStatus.DISPUTING:
      text = (
        <div>
          <div className={styles.boardBgTitle}>争议订单</div>
          <div className={styles.boardBgDesc}>
            争议订单将由官方客服
            <br />
            介入协助处理
          </div>
        </div>
      );
      break;
    case OrderStatus.CANCELED_BY_OFFICIAL:
      text = (
        <div>
          <div className={styles.boardBgTitle}>平台取消交易</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case OrderStatus.CONFIRMED_BY_OFFICIAL:
      text = (
        <div>
          <div className={styles.boardBgTitle}>平台交易完成！</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case OrderStatus.DEAL:
      text = (
        <div>
          <div className={styles.boardBgTitle}>交易完成！</div>
          <div className={styles.boardBgDesc}>感谢您使用VipPay</div>
        </div>
      );
      break;
    case OrderStatus.BUYER_NOT_APPEALS:
      text = (
        <div>
          <div className={styles.boardBgTitle}>卖家未收到款</div>
          <div className={styles.boardBgDesc}>
            超时未提交异议
            <br />
            系统自动结束交易
          </div>
        </div>
      );
      break;
    default:
      text = <div>状态错误:{state}</div>;
  }
  return (
    <TradeBoard
      className={styles.board}
      contentClassName={styles.boardContent}
      backgroundClassName={cn("buy-trade-board-bg", state)}
      background={
        <>
          <div className={styles.content}>
            <div className={cn("buy-trade-board-status", state)}></div>
            {text}
          </div>
        </>
      }
    >
      {children}
    </TradeBoard>
  );
};

interface PreviewScreenShotProps extends ComponentBase.Component {
  src: string;
}
export const PreviewScreenShot = ({ src }: PreviewScreenShotProps) => {
  const [visible, { toggle: toggleVisible }] = useToggle();
  return (
    <>
      <Image
        fit="cover"
        src={src}
        alt="付款凭证"
        className={styles.paidScreenShot}
        onClick={toggleVisible}
      />
      <ImageViewer image={src} visible={visible} onClose={toggleVisible} />
    </>
  );
};

interface PaidScreenShotUploaderProps extends ComponentBase.Component {
  onUpload: (file: File) => void;
  onDelete: () => void;
  voucher: string;
}
const PaidScreenShotUploader = ({
  onUpload,
  onDelete,
  voucher,
}: PaidScreenShotUploaderProps) => {
  if (voucher) {
    return (
      <div className={styles.uploader}>
        <PreviewScreenShot src={voucher} />
        <Button
          className={styles.uploaderDelete}
          fill="none"
          onClick={onDelete}
        >
          <CloseCircleOutline fontSize={24} />
        </Button>
      </div>
    );
  }

  const fileUpload = async (file: File): Promise<ImageUploadItem> => {
    try {
      if (file) {
        const messages = validateFileSize(file.size, 5, "MB");
        if (messages){
          Toast.show(messages);
          return {
            url: '',
          };
        }
        onUpload(file);
        return {
          url: URL.createObjectURL(file),
        };
      } else {
        Toast.show("上传错误");
        throw new LocalError(
          EC.INVALID_FILE,
          "上传付款凭证，从files无法获取到文件"
        );
      }
    } catch (error) {
      Toast.show("上传错误");
      //TODO： 上传错误
      Toast.show("上传错误");
      console.error(error);
      return {
        url: '',
      };
    }
  }
  const h5pUpload = ()=>{
    window.h5p.uploadImage((blob, name, type, filePath) => {
      const files = new File([blob],name||"",{ type: type });
      fileUpload(files).then(res=>{});
    })
  }

  return (
    <div className={styles.uploader}>
      <Icon name="circle-uploader" size="32px" />
      <span className={styles.plsUploadPaidScreenShot}>请上传付款凭证</span>
      {window.plus ? (<div className={styles.h5pUpload} onClick={h5pUpload}></div>):null }
      <ImageUploader
          className={styles.uploadInput}
          multiple={false}
          columns={0}
          renderItem={() => null}
          preview={false}
          upload={fileUpload}
        >
      </ImageUploader>
      {/* <input
        type="file"
        accept="image/*"
        className={styles.uploadInput}
        title="上传付款凭证"
        onChange={(e) => {
          try {
            const input = e.target;
            const file = (input.files || [])[0];
            if (file) {
              const messages = validateFileSize(file.size, 5, "MB");
              if (messages) return Toast.show(messages);
              onUpload(file);
            } else {
              throw new LocalError(
                EC.INVALID_FILE,
                "上传付款凭证，从files无法获取到文件"
              );
            }
          } catch (error) {
            //TODO： 上传错误
            console.error(error);
          }
        }}
      /> */}
    </div>
  );
};

const TradingNotice = () => {
  return (
    <div className={styles.tradingNotice}>
      <div>
        1.请务必使用您实名认证的付款方式进行转账，否则卖家有权利 延迟或拒绝转币
      </div>
      <div>
        2.转账成功后请上传真实付款凭证，对于提供虚假付款凭证用户
        平台将予以严肃处理，恶意提供虚假转账用户平台封号处理
      </div>
      <div>3.上传真实付款凭证后点击「我已转账」等待商家审核</div>
    </div>
  );
};
